import { render, staticRenderFns } from "./ItemTree.vue?vue&type=template&id=139c92de&"
import script from "./ItemTree.vue?vue&type=script&lang=ts&"
export * from "./ItemTree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports